/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

export interface SummaryCancelSummarizationPostRequest {
    processId?: string;
}

export interface SummarySummarizeTextFilePostRequest {
    processId?: string;
    fileName?: string;
    outputLanguage?: string;
    maxOutputSentences?: number;
    fileSizeInBytes?: number;
}

/**
 * 
 */
export class SummaryApi extends runtime.BaseAPI {

    /**
     */
    async summaryCancelSummarizationPostRaw(requestParameters: SummaryCancelSummarizationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['processId'] != null) {
            headerParameters['processId'] = String(requestParameters['processId']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Summary/CancelSummarization`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async summaryCancelSummarizationPost(requestParameters: SummaryCancelSummarizationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.summaryCancelSummarizationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async summarySummarizeTextFilePostRaw(requestParameters: SummarySummarizeTextFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['processId'] != null) {
            headerParameters['processId'] = String(requestParameters['processId']);
        }

        if (requestParameters['fileName'] != null) {
            headerParameters['fileName'] = String(requestParameters['fileName']);
        }

        if (requestParameters['outputLanguage'] != null) {
            headerParameters['outputLanguage'] = String(requestParameters['outputLanguage']);
        }

        if (requestParameters['maxOutputSentences'] != null) {
            headerParameters['maxOutputSentences'] = String(requestParameters['maxOutputSentences']);
        }

        if (requestParameters['fileSizeInBytes'] != null) {
            headerParameters['fileSizeInBytes'] = String(requestParameters['fileSizeInBytes']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Summary/Summarization`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async summarySummarizeTextFilePost(requestParameters: SummarySummarizeTextFilePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.summarySummarizeTextFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
